<template>
  <slide-x-left-transition :duration="400+(index*100)" :delay="300+(index*100)">
    <ion-card v-if="show" mode="ios" class="item-loyalty-activation">
      <ion-item>
        <ion-label mode="md">
          <p v-if="status === 'active'" class="pulse-status">
            <span class="dot" title="Trwa"></span>
            <span class="dot-text">Trwa</span>
          </p>
          <h3 class="text-up" style="margin: 10px 0">{{ title }}</h3>
          <p>Dostępna od: {{ started_at }}</p>
          <p>Dostępna do: {{ ended_at }}</p>
        </ion-label>
      </ion-item>
      <ion-card-content>
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goTo('LoyaltyActivationsSingle', slug)">Czytaj więcej
        </ion-button>
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goTo(url_to_legal)">Regulamin
        </ion-button>
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goTo(url_to_conditions)">Warunki akcji
        </ion-button>
      </ion-card-content>
    </ion-card>
  </slide-x-left-transition>
</template>

<script>
  import goTo from '@/mixins/goto';

  export default {
    name: 'ItemLoyaltyActivation',
    props: ['index','slug','status','image','title','started_at','ended_at','url_to_legal','url_to_conditions'],
    mixins: [goTo],
    data() {
      return {
        show: false
      }
    },
    mounted() {
      this.show = true;
    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  ion-card{
    margin: 0 0 20px 0px;
  }
  ion-thumbnail{
    width: 65px;
    height: 60px;
    padding: 15px 0;
    text-align: center;
  }
</style>